import React, { lazy, Suspense, useEffect, useState } from "react";
import "./Home.scss";
import { NavLink } from "react-router-dom";
import news from "../../all__news.json";
import ArticalBox from "../../components/ArticalBox/ArticalBox";
import Calendar from "../../components/Calendar/Calendar";
import AdManagerSlot from "../../components/AdvModule/AdManagerSlot";
import { calendarYears } from "../../components/Calendar/calendar-data/calendar-data.js";
import { useGlobalLocation } from "../../shared/LocationContext";
import Zadusnice from "../../components/Zadusnice/Zadusnice";
import MultiplexAd from "../../components/AdvModule/MultiplexAd";
import CalendarMonthsLinks from "../../components/CalendarMonthsLinks/CalendarMonthsLinks";
import { useIdContext } from "../../shared/IdProvider";
import Newsletter from "../../components/NewsLetter/NewsLetter";
import { prodavnicaKategorije } from "../../shared/shared";
import { getProducts } from "../../shop/api/products";

const Widget = lazy(() => import("../../UI/Widget/Widget.js"));

const formatPrice = (num) => Number(num).toLocaleString("sr-RS") + " RSD";

export default function Home() {
  const location = useGlobalLocation();
  const { yearIndex } = useIdContext();
  const [featuredIkone, setFeaturedIkone] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    getProducts().then((data) => setFeaturedIkone(data.slice(0, 8))).catch(console.error);
  }, []);

  return (
    <div className="home">

      {/* ── HERO ── */}
      <section className="home__hero">
        <div className="home__hero-inner">
          <div className="home__hero-ornament">✦ ✝ ✦</div>
          <h1 className="home__hero-title">Ikone koje žive vekovima</h1>
          <p className="home__hero-sub">
            Ručno oslikane pravoslavne ikone pisane u vizantijskoj tradiciji —
            jajnom temperom i listićima zlata
          </p>
          <div className="home__hero-btns">
            <NavLink to="/prodavnica" className="home__hero-btn home__hero-btn--primary">
              Pogledaj ikone
            </NavLink>
          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <section className="home__stats">
        <div className="home__stat">
          <span className="home__stat-num">120+</span>
          <span className="home__stat-label">Ikona u ponudi</span>
        </div>
        <div className="home__stat-divider" />
        <div className="home__stat">
          <span className="home__stat-num">18</span>
          <span className="home__stat-label">Ikonopisaca</span>
        </div>
        <div className="home__stat-divider" />
        <div className="home__stat">
          <span className="home__stat-num">10+</span>
          <span className="home__stat-label">Godina tradicije</span>
        </div>
      </section>

      {/* ── KATEGORIJE ── */}
      <section className="home__categories">
        <div className="home__section-header">
          <h2 className="home__section-title">Kategorije ikona</h2>
          <div className="home__section-line" />
        </div>
        <div className="home__cat-grid">
          {prodavnicaKategorije.map((kat, i) => (
            <NavLink key={i} to="/prodavnica" className="home__cat-card">
              <div className="home__cat-info">
                <h3 className="home__cat-title">{kat.title}</h3>
              </div>
              <span className="home__cat-arrow">→</span>
            </NavLink>
          ))}
        </div>
      </section>

      {/* ── FEATURED IKONE ── */}
      <section className="home__featured">
        <div className="home__section-header">
          <h2 className="home__section-title">Izdvojene ikone</h2>
          <div className="home__section-line" />
        </div>
        <div className="home__icons-grid">
          {featuredIkone.map((ikona) => (
            <NavLink key={ikona.id} to={`/prodavnica/${ikona.slug}`} className="home__icon-card">
              <div className="home__icon-img-wrap">
                <img src={ikona.images?.[0]} alt={ikona.name} loading="lazy" />
                <span className="home__icon-badge">{ikona.attributes?.tehnika}</span>
              </div>
              <div className="home__icon-body">
                <h3 className="home__icon-title">{ikona.name}</h3>
                <p className="home__icon-meta">{ikona.attributes?.tehnika} · {ikona.attributes?.dimenzije}</p>
                <p className="home__icon-price">{formatPrice(ikona.price)}</p>
              </div>
            </NavLink>
          ))}
        </div>
      </section>

      <div className="banner-wrapper bilbord">
        <AdManagerSlot adUnitPath={location.pathname} slotNumber={"div-gpt-ad-1723658374440-0"} />
      </div>

      {/* ── EXISTING CONTENT (Kalendar + Zadušnice) ── */}
      <section className="home__section-header home__calendar-header">
        <h2 className="home__section-title">Crkveni kalendar i informacije</h2>
        <div className="home__section-line" />
      </section>

      <section className="home__main-wrapper">
        <div className="home__main-left">
          <div className="home__main-left links">
            <h2>Crkveni kalendar 2026. godine po mesecima:</h2>
            <CalendarMonthsLinks />
          </div>
          <Calendar shortCal={6} soc={false} />
        </div>

        <div className="home__main-right">
          <Zadusnice setYear={2026} boxTitle={`🕯 Zadušnice u ${2026}. godini`} data={calendarYears[0].item_list[yearIndex]} />
          <ArticalBox n={20} classes={"test1 mainBox"} data={news[20]} />
          <Newsletter />
          <div className="banner-wrapper xl_sticky">
            <AdManagerSlot adUnitPath={location.pathname} slotNumber={"div-gpt-ad-1723682121612-0"} />
          </div>
        </div>
      </section>

      <div className="banner-wrapper">
        <AdManagerSlot adUnitPath={location.pathname} slotNumber={"div-gpt-ad-1724367417806-0"} />
      </div>

      <div className="home__box__4 contEx">
        <Suspense fallback={<div></div>}>
          <Widget />
        </Suspense>
      </div>
      <MultiplexAd />
    </div>
  );
}
